import { Grid } from "@mui/material";
import { MissionProtocolSensorData } from "../MissionProtocolSensorData";
import { MissionProtocolStageTableLiteral } from "./MissionProtocolStageTableLiteral";

export function MissionProtocolLiteral({
    pipelineTemplate,
    TGDTSortedByDatatype,
}) {
    return (
        <Grid container spacing={2}>
            <Grid size={4}>
                <MissionProtocolSensorData
                    isLiteral
                    pipelineTemplate={pipelineTemplate}
                />
            </Grid>
            <Grid size={8}>
                <MissionProtocolStageTableLiteral
                    TGDTSortedByDatatype={TGDTSortedByDatatype}
                />
            </Grid>
        </Grid>
    );
}
